import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/components/store'

Vue.use(VueRouter)

function loadView (view) {
  return () => import(
    /* webpackChunkName: "view-[request]" */
    /* webpackMode: "lazy" */
    /* webpackPrefetch: 0 */
    /* webpackPreload: 0 */
    `@/views/${view}.vue`)
  // const  import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: loadView('Login')
  }, {
    path: '/change-password/:uidb64/:token',
    name: 'change-password',
    component: loadView('ChangePassword')
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: loadView('Dashboard'),
    meta: { requiresAuth: true }
  }, {
    path: '/dashboard/:uuid',
    name: 'room',
    component: loadView('Room'),
    meta: { requiresAuth: true }
  }, {
    path: '/dashboard/:uuid/event/:event_uuid',
    name: 'room-history',
    component: loadView('Room'),
    meta: { requiresAuth: true }
  }, {
    path: '/dashboard/:uuid/notes',
    name: 'notes',
    component: loadView('Notes'),
    meta: { requiresAuth: true }
  }, {
    path: '/params',
    name: 'params',
    component: loadView('Params'),
    meta: { requiresAuth: true }
  }, {
    path: '/params/:uuid',
    name: 'params_filter',
    component: loadView('Params'),
    meta: { requiresAuth: true }
  }, {
    path: '/params/:uuid/users/:user_uuid',
    name: 'params_filter_user',
    component: loadView('Params'),
    meta: { requiresAuth: true }
  }, {
    path: '/params/own',
    name: 'params-own',
    component: loadView('Params'),
    meta: { requiresAuth: true }
  }, {
    path: '/password-reset',
    name: 'password-reset',
    component: loadView('PasswordReset')
  }, {
    path: '/stats',
    name: 'stats',
    component: loadView('Statistics'),
    meta: { requiresAuth: true }
  }, {
    path: '/stats/own',
    name: 'stats-own',
    component: loadView('Statistics'),
    meta: { requiresAuth: true }
  }, {
    path: '/stats/:filter_by/:uuid',
    name: 'stats_filter',
    component: loadView('Statistics'),
    meta: { requiresAuth: true }
  }, {
    path: '/stats/:filter_by/:uuid/:and_by/:other_uuid',
    name: 'stats_filter_twice',
    component: loadView('Statistics'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  store.commit('global/hideModal')
  store.commit('global/hideOverlay')
  store.commit('global/hideUserMenu')
  store.commit('global/hideRoomMenu')
  store.commit('global/hideEmojiPicker')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.getters['user/getToken'] === '') {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
